<template>
  <div class="splash-page">
    <!-- 启动页整屏成品图（全程在线 一网通办 + 江苏智慧人社） -->
    <img src="@/assets/icons/splash.jpg" class="splash-img" alt="江苏智慧人社" />
    <!-- 覆盖图内右上角「跳过」胶囊的透明点击热区：点击立即进入首页 -->
    <div class="skip-hit" @click="enterApp">跳过</div>
  </div>
</template>

<script>
export default {
  name: 'Splash',
  mounted() {
    // 需求：仅未登录冷启动展示2.5s启动页；已登录冷启动直接进首页
    if (localStorage.getItem('jszhrs_logged_in') === '1') {
      this.$router.replace('/home')
      return
    }
    // 2.5s 后自动进入首页（游客可浏览）
    this.timer = setTimeout(() => this.enterApp(), 2500)
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  },
  methods: {
    enterApp() {
      clearTimeout(this.timer)
      // replace：物理返回键不会回到启动页
      if (this.$route.path === '/splash') {
        this.$router.replace('/home')
      }
    }
  }
}
</script>

<style scoped>
/* 全屏覆盖，脱离普通文档流，避免滚动容器影响 */
.splash-page {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3000;
  /* 兜底渐变与启动图顶/底色一致，极端宽高比机型出现留白时无缝衔接 */
  background: linear-gradient(180deg, #339DDB 0%, #48B99D 100%);
  overflow: hidden;
}
.splash-img {
  display: block;
  width: 100%;
  height: 100%;
  /* 宽度铺满，顶部对齐：超高机型只可能裁掉底部纯色渐变区，保证右上角「跳过」胶囊完整 */
  object-fit: cover;
  object-position: center top;
}
/* 透明按钮：盖在启动图内右上角「跳过」胶囊上，热区略大于胶囊便于点按 */
.skip-hit {
  position: absolute;
  top: calc(34 * var(--w));
  right: calc(36 * var(--w));
  width: calc(250 * var(--w));
  height: calc(104 * var(--w));
  display: flex;
  align-items: center;
  justify-content: center;
  color: transparent;
  font-size: calc(1 * var(--w));
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/pages/Splash.vue